/**
 * Static feature flags for sphinx.
 *
 * Replaces PostHog's `useFeatureFlagEnabled` (posthog-js/react) with a
 * hardcoded map — telemetry and remote flag evaluation are removed. Flags for
 * kept surfaces (Servers, Playground, Evaluate, Tools/Resources/Prompts,
 * Tasks, OAuth Debugger, Settings) default to their stable/GA behavior; flags
 * for stripped surfaces (swarms, scenarios, sessions, learning, conformance,
 * billing, registry) are false. Flip a value here to change behavior.
 */
export const FEATURE_FLAGS: Record<string, boolean> = {
  // Kept: host templates used by evals.
  "claude-code-host-enabled": true,
  "codex-host-enabled": true,
  // Kept: MCP tasks surface.
  "mcp-tasks": true,

  // Stripped or non-GA surfaces.
  "billing-entitlements-ui": false,
  "sandboxes-enabled": false,
  "computers-enabled": false,
  "local-computer-enabled": false,
  "credit-estimate-enabled": false,
  "discord-agent": false,
  "plugins-enabled": false,
  "tool-quality-enabled": false,
  "slack-agent-org-settings": false,
  "skills-enabled": false,
  // Kept auth mode (Cross-App Access on server connections) but the option
  // stays behind its flag, off by default as it was upstream.
  xaa: false,
};

/**
 * Same shape as posthog-js/react's hook: `boolean | undefined` (undefined
 * meant "flags still loading" there; here every flag resolves immediately).
 */
export function useFeatureFlagEnabled(flag: string): boolean | undefined {
  return FEATURE_FLAGS[flag] ?? false;
}
